// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer":"RedirectImage_bannerContainer__KUDpy","bannerTitle":"RedirectImage_bannerTitle__V6leK","img":"RedirectImage_img__ARaep"};